import React from "react";
import { Component, Fragment } from "react";
import {
	Progress,
	Card,
	CardBody,
  CardTitle,
	Row,
	Col,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	ButtonDropdown,
	Tooltip
} from 'reactstrap';

import img1 from '../../../assets/images/background/active-bg.png';
import Moment from 'moment';
import { authenticationService } from '../../../jwt/_services';

class TopComponents extends React.Component {

	noResults = true;
	intervalID = 0;

	constructor(props) {
    super(props);
    this.state = {
			rSelected: 3,
			topComponents: [],
			colors: [{color:'warning'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}, {color:'cyan'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'},{color:'warning'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}, {color:'cyan'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}, {color:'warning'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}, {color:'cyan'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'},{color:'warning'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}, {color:'cyan'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}],
			noDevices: false,
			noDataForDevices: false,
			currentDataSetting: 0,
			startDate: Moment().subtract(3, 'year').format('YYYY-MM-DD'),
			endDate: Moment().format('YYYY-MM-DD'),
			currentDate: Moment().format('YYYY-MM-DD'),
			isOpen: false,
			currentItem: "Gemini",
			tooltipOpen: false,
			deviceList: JSON.parse(localStorage.getItem('deviceList')),
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			ratioRange: 0,
      bomData: [],
			batchesData: [],
			batchSelect: "ALL",
	  };

		this.toggleDropDown = this.toggleDropDown.bind(this);
		//this.handleSubmit = this.handleSubmit.bind(this);
		//this.handleChange = this.handleChange.bind(this);

		this.toggleTooltip = this.toggleTooltip.bind(this);
  }

	async componentDidMount() {

		this.getBatchData();


    this.getBOMData();
		this.getData();
		//this.intervalID = setInterval(this.getData, 5000);
	}

	getBatchData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-batches";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all Batches data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ batchesData: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	onChangeBatch = (event) => {

		console.log("input id: " + event.target.id);
		console.log("input value: " + event.target.value);

		let id = event.target.id;
		let value = event.target.value;

		//console.log("repairLog: " + JSON.stringify(repairLog));

		this.setState({ batchSelect: value });

		setTimeout(() => this.getData(), 500);

	}

	toggleTooltip() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

	toggleDropDown() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

	selectDropDownItem(id, title) {

		this.setState({ topProcedures: [] });

    this.setState({
      currentItem: title,
			currentDataSetting: id
    });

		if (id==1) {
			this.setState({ startDate: Moment().subtract(1, 'week').format('YYYY-MM-DD') });
		} else if (id==2) {
			this.setState({ startDate: Moment().subtract(1, 'month').format('YYYY-MM-DD') });
		}

		this.setState({ endDate: Moment().format('YYYY-MM-DD') });
		this.getData();
  }

	componentWillUnmount() {
		//console.log("top-procedures componentWillUnmount");
		clearInterval(this.intervalID);
	}

  getBOMData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-bill-of-materials";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all BOM data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ bomData: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	getData = async () => {

		var productName = this.props.productName;

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-top-components?Quantity=30&ProductName="+productName;

		if (this.state.batchSelect!="ALL") {
			url = url+"&BatchName="+this.state.batchSelect;
		}

		try {

	    const response = await fetch(url, {
	      method: 'GET',
	      headers: {
	        Authorization: this.state.currentUser.jwtToken
	      },
	    });

	    const body = await response.json();
	    console.log("topprocedures body response: " + JSON.stringify(body));

	    if (body.status == 'Success') {
	      if (body.response.length>0) {
	        var largest = 100;
	        for (var i=0; i < body.response.length; i++) {
	          if (body.response[i].total > largest) {
	            largest = body.response[i].total;
	          }
	        }
	        console.log("topprocedures body response LARGEST: " + largest);
	        this.setState({ topComponents: body.response }, () => console.log(this.state.topComponents));
	        this.setState({
	          noDataForDevices: false,
	          ratioRange: 2*largest
	        });
	      } else {
	        this.setState({
	          noDataForDevices: true
	        });
	      }
	    } else {
	      this.setState({
	        noDataForDevices: true
	      });
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	}

	getColor(presetID) {

		var color = "success";

		if (presetID>=1 && presetID<=5) {
			color = "success";
		} else if (presetID>=11 && presetID<=19) {
			color = "info";
		} else if (presetID>=21 && presetID<=23) {
			color = "yellow";
		}

		return color;

	}

  getName(bomID) {

		var name = "N/A";

    console.log("bomID: " + bomID);

    const result = this.state.bomData.filter(bom => bom.id==bomID);

    name = result[0].Description;

		return name;

	}

	render() {

		var batchesList = [];

		var currentProduct = 1;

		if (this.props.productName=="EVO") {
			currentProduct = 2;
		}

		if (currentProduct) {
			batchesList = this.state.batchesData.filter(batch => batch.ProductID==currentProduct);
		}

		return (
			/*--------------------------------------------------------------------------------*/
			/* Used In Dashboard-1 [Classic]                                                  */
			/*--------------------------------------------------------------------------------*/
			<Card className="card-hover">
				<CardBody style={{ height: 700 }}>
					<Row>
						<Col xs="6" md="6" lg="6" className="text-left">
							<CardTitle>Top Replaced Components ({this.props.productName})
							<i style={{color: '#ffffff'}} className="mdi mdi-information-outline ml-1" id="TopProceduresTooltip"/>
							<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TopProceduresTooltip" toggle={this.toggleTooltip}>
								Shows the most common replaced components used by device model.
							</Tooltip>
							</CardTitle>
						</Col>
						<Col xs="6" md="6" lg="6" className="text-right">
							<Row className="ml-2">
								<Col xs="12" md="12" lg="12" className="">
									<div className="float-right ml-2" style={{ width: '140px' }}>
										<Input style={{height: '30px', padding: '3px'}} type="select" name="batchSelect" id="batchSelect" value={this.state.batchSelect} onChange={this.onChangeBatch}>
											<option value="ALL">ALL</option>
											{batchesList.map((batch, i) => (
												<option value={batch.Name}>{batch.Name}</option>
											))}
										</Input>
									</div>
									<div className="float-right text-right" style={{ width: '60px' }}>
										<h6 style={{ lineHeight: '1.9' }}>Batch:</h6>
									</div>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row>
						<Col xs="6" md="6" lg="6" className="text-left">
							<span>Total</span>
						</Col>
						<Col xs="6" md="6" lg="6" className="text-right">
							<span>Description</span>
						</Col>
					</Row>
					{this.state.noDevices ? (
						<div className="mt-5 text-center">
							<h5>User has no devices</h5>
						</div>
					) : (
            <Fragment>
            <div className="ml-auto mt-1" style={{height: '555px', overflow: "scroll"}}>
                {this.state.noDataForDevices ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '100%'}}>
                    <h5>No data for user's devices</h5>
                  </div>
                ) : (
                  <div className="pt-1">
                    {this.state.topComponents.map((component, i) => (
                      <Fragment>
                      <Row key={i}>
                        <Col xs="6" md="6" lg="6" className="text-left">
                          <span>{component.total}</span>
                        </Col>
                        <Col xs="6" md="6" lg="6" className="text-right">
                          {this.state.bomData.length>0 &&
                            <span>{component.Description}</span>
                          }
                        </Col>
                      </Row>
                      <Progress multi className="mt-1 mb-3">
                        <Progress bar color={this.state.colors[i].color} value={(component.total/this.state.ratioRange)*100} />
                      </Progress>
                      </Fragment>
                    ))}
                  </div>
                )}
            </div>
            </Fragment>
					)}
				</CardBody>
			</Card>

		);
	}
}

export default TopComponents;
